import React from "react";

function Loading({message = ""}) {
  return (
    <div className="d-flex justify-content-center align-items-center mt-4">
      <div className="spinner-border text-primary me-2" role="status">
        <span className="visually-hidden">{`Loading...`}</span>
      </div>
      <strong>{message}</strong>
    </div>
  );
}

export default Loading;